import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

// The Firebase Auth web-config is injected at BUILD time and is TARGET-SCOPED by the
// deploy workflow (.github/workflows/deploy-frontend.yml). RULE 0 invariant: a
// buildgravity-dialer (dvw4ea) build is ALWAYS handed buildgravity-platform auth
// values; only an explicit metabus-prod deploy is handed metabus-prod auth. This file
// only READS the injected VITE_FIREBASE_* values - the target separation is enforced
// in the workflow's `Build frontend` env (and asserted in
// backend/tests/unit/test_deploy_workflow_parameterization.py). Do NOT hardcode a
// project here - it would defeat the per-target separation.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
